import axios from "axios";
import { toast } from "sonner";

export const FETCH_CATEGORIES_SUCCESS = "FETCH_CATEGORIES_SUCCESS";
export const FETCH_SUBCATEGORY_SUCCESS = "FETCH_SUBCATEGORY_SUCCESS";
export const FETCH_CATEGORY_STATS_SUCCESS = "FETCH_CATEGORY_STATS_SUCCESS";
export const ADD_CATEGORY_SUCCESS = "ADD_CATEGORY_SUCCESS";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";
export const FETCH_SUBCATEGORY_DETAILS_SUCCESS =
    "FETCH_SUBCATEGORY_DETAILS_SUCCESS";

export const fetchCategories = () => async (dispatch) => {
    await axios
        .get("/api/category")
        .then((response) => {
            dispatch({
                type: FETCH_CATEGORIES_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            toast.error(error?.response?.data?.error, {
                duration: 3000,
            });
        });
};

export const fetchSubCategory = (subcategoryName) => async (dispatch) => {
    await axios
        .get(`/api/category/subcategory/${subcategoryName}`)
        .then((response) => {
            dispatch({
                type: FETCH_SUBCATEGORY_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            toast.error(error?.response?.data?.error, {
                duration: 3000,
            });
        });
};

export const fetchCategoryStats = () => async (dispatch) => {
    try {
        const response = await axios.get("/api/category/stats");
        dispatch({
            type: FETCH_CATEGORY_STATS_SUCCESS,
            payload: response.data,
        });
    } catch (error) {
        toast.error(
            error?.response?.data?.error || "Failed to fetch category stats",
            {
                duration: 3000,
            }
        );
    }
};

export const addCategory = (categoryData) => async (dispatch) => {
    try {
        const response = await axios.post("/api/category", categoryData);
        dispatch({
            type: ADD_CATEGORY_SUCCESS,
            payload: response.data,
        });
        toast.success("Category added successfully");
        // Refresh categories after adding
        dispatch(fetchCategories());
    } catch (error) {
        toast.error(error?.response?.data?.error || "Failed to add category");
    }
};

export const deleteCategory = (categoryId) => async (dispatch) => {
    try {
        await axios.delete(`/api/category/${categoryId}`);
        dispatch({
            type: DELETE_CATEGORY_SUCCESS,
            payload: categoryId,
        });
        toast.success("Category deleted successfully");
        // Refresh categories after deleting
        dispatch(fetchCategories());
    } catch (error) {
        toast.error(
            error?.response?.data?.error || "Failed to delete category"
        );
    }
};

export const updateCategory = (categoryData) => async (dispatch) => {
    try {
        // First fetch the category details to get the ID
        const detailsResponse = await axios.get(
            `/api/category/details/${categoryData.category}/${categoryData.subCategory}`
        );
        const categoryId = detailsResponse.data.id;

        const response = await axios.put(
            `/api/category/${categoryId}`,
            categoryData
        );
        dispatch({
            type: UPDATE_CATEGORY_SUCCESS,
            payload: response.data,
        });
        toast.success("Category updated successfully");
        // Refresh categories after updating
        dispatch(fetchCategories());
    } catch (error) {
        toast.error(
            error?.response?.data?.error || "Failed to update category"
        );
    }
};

export const fetchSubCategoryDetails =
    (category, subcategory) => async (dispatch) => {
        try {
            const response = await axios.get(
                `/api/category/details/${category}/${subcategory}`
            );
            dispatch({
                type: FETCH_SUBCATEGORY_DETAILS_SUCCESS,
                payload: response.data,
            });
            return response.data;
        } catch (error) {
            toast.error(
                error?.response?.data?.error ||
                    "Failed to fetch subcategory details"
            );
            throw error;
        }
    };
